'use client';
import { MouseEvent, useRef } from 'react';
import styles from './RadioItem.module.scss';
import cx from 'classnames';

type BaseOptionType = {
  label: string;
  labelAdditional?: string;
};

export type OptionType = BaseOptionType & { [key: string]: unknown };

type Props = {
  /**
   * Input label text
   */
  label: string;
  labelAdditional?: string;
  selectedOption: OptionType;
  setDropdownOpen: (val: boolean) => void;
  setSelectedOption: (args: OptionType) => void;
  className?: string;
  dataTestId?: string;
  onChange?: (...args: any[]) => void;
};

const RadioItem = ({
  label,
  selectedOption,
  setDropdownOpen,
  setSelectedOption,
  className,
  labelAdditional,
  dataTestId,
  onChange,
}: Props) => {
  const containerRef = useRef<HTMLLabelElement>(null);

  const isSelectedOption = label === selectedOption.label;

  const handleChange = () => {
    setSelectedOption({ label, labelAdditional });
    if (onChange) {
      onChange();
    }
  };

  const handleClick = (e: MouseEvent<HTMLInputElement>) => {
    if (e.type === 'click') {
      const clickEvent = e as MouseEvent<HTMLInputElement>;
      if (clickEvent.clientX !== 0 && clickEvent.clientY !== 0) {
        setDropdownOpen(false);
      }
    }
  };

  const labelContent = `${label} ${
    labelAdditional ? ` (${labelAdditional})` : ''
  }`;

  return (
    <label className={cx(styles.label, className)} ref={containerRef}>
      <input
        data-test-id={dataTestId}
        role='option'
        aria-selected={isSelectedOption}
        className={styles.input}
        type='radio'
        name='radio'
        onChange={handleChange}
        onClick={handleClick}
        defaultChecked={isSelectedOption}
      />
      {labelContent}
    </label>
  );
};

export default RadioItem;
